import {Component, ViewEncapsulation, inject} from '@angular/core';
import {FormButtonComponent} from "../../../shared/elements/form-button/form-button.component";
import {TooltipComponent} from "../../../shared/elements/tooltip/tooltip.component";
import {RouterService} from "../../../shared/services/router.service";
import {UserService} from "../../../shared/services/user.service";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {NavService} from "../../../shared/services/nav.service";
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-bar-icons',
    imports: [
        FormButtonComponent,
        TooltipComponent,
        TranslatePipe
    ],
    templateUrl: './bar-icons.component.html',
    styleUrl: './bar-icons.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class BarIconsComponent {
  public routerService: RouterService = inject(RouterService);
  private userService: UserService = inject(UserService);
  public navService: NavService = inject(NavService);

  public iconBarVisible: boolean = false;

  public constructor() {
    this.userService.iconBarVisible
    .pipe(takeUntilDestroyed())
    .subscribe((value) => {
      this.iconBarVisible = value;
    });
  }

}
